import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlaceholder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPlaceholder"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H7V5H5V7H3V3ZM9.5 3H14.5V5H9.5V3ZM17 3H21V7H19V5H17V3ZM5 9.5V14.5H3V9.5H5ZM21 9.5V14.5H19V9.5H21ZM5 17V19H7V21H3V17H5ZM21 17V21H17V19H19V17H21ZM9.5 19H14.5V21H9.5V19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlaceholder;
